/* global fundHistory */
import Chart from 'chart.js/auto';
import $ from 'jquery';

const FundHistory = (el) => {
    const $el = $(el);
    const $chartCanvas = $el.find('.js-chart');
    const $select = $el.find('.js-fund-history-select');

    const labels = Object.keys(fundHistory[$select.val()]['history']);
    const data = Object.values(fundHistory[$select.val()]['history']);

    const percentageData = data.map(value => (value * 100));
    
    const chart = new Chart($chartCanvas, {
        type: 'bar',
        data: {
            labels: labels,
            datasets: [{
                data: percentageData,
                borderWidth: 1,
            }],
        },
        options: {
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    enabled: true,
                    callbacks: {
                        label: function(item) {
                            return item.parsed.y + '%';
                        },
                    },
                },
            },
            backgroundColor: '#212d40',
        },
    });

    // Function to update the chart data
    const updateChart = (selected) => {
        // Update chart data
        chart.data.labels = Object.keys(fundHistory[selected]['history']);
        chart.data.datasets[0].label = selected;
        const values = Object.values(fundHistory[selected]['history']);
        chart.data.datasets[0].data = values.map(value => (value * 100));
        chart.update();

        // Update history start date text
        $el.find('.js-history-start-date').html(fundHistory[selected]['startDateString']);
    };

    // Handler for select change
    $select.on('change', function () {
        const selected = $(this).val();
        updateChart(selected);
    });
};

export default FundHistory;